import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import Vuelidate from "vuelidate";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "./assets/styles/main.scss";

Vue.use(require("vue-moment"));
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
